import i18n from 'i18next'
import { PurchaseChannel, PurchaseChannelConfig } from '../types'

export interface PurchaseChannelDisplayState {
  channel: PurchaseChannel
  href: string
  label: string
  isPrimary: boolean
  subText?: string
}

export function buildPurchaseChannelDisplayStates(
  purchaseChannels: PurchaseChannelConfig[],
): PurchaseChannelDisplayState[] {
  const primaryChannel = purchaseChannels.find(channel => channel.available)?.key

  return purchaseChannels.map(channel => ({
    channel: channel.key,
    href: i18n.t(`purchaseButtons.${channel.key}Url`, { ns: 'landingPage' }),
    label: i18n.t(`purchaseButtons.${channel.key}Label`, { ns: 'landingPage' }),
    isPrimary: channel.key === primaryChannel,
    subText: channel.available
      ? channel.key === 'amazon' && channel.saleActive
        ? i18n.t('purchaseButtons.amazonSaleText', { ns: 'landingPage' })
        : undefined
      : i18n.t('purchaseButtons.soldOutText', { ns: 'landingPage' }),
  }))
}
